import { type CountryCode, type ProjectCode } from '@constants'
import { getWordPressLocale } from '@utils/getWordPressLocale'
import { useApiPaymentTransaction } from '../eCommerceV2/useApiPaymentTransaction'
import { useApiWordPressOrder } from '../eCommerceV2/useApiWordPressOrder'
import { useApiGetGuestPaymentTransactionRequest } from '../fortune/useApiGetGuestPaymentTransactionRequest'

interface UseOrderDetailProps {
  transactionId?: string
  /** orderHash 新版購物車訪客訂單 Hash，目前只有 DCS, LM */
  orderHash?: string | null
  countryCode?: CountryCode
  orderId?: string
  projectCode?: ProjectCode
}

export function useOrder(props: UseOrderDetailProps) {
  const { transactionId, orderHash, countryCode, orderId, projectCode } = props || {}
  const isGuest = !!orderHash
  const isTransactionOrder = typeof transactionId === 'string' || typeof orderHash === 'string'
  const language = getWordPressLocale()
  const isWordPressOrder = typeof orderId === 'string' && countryCode && projectCode
  /** For members */
  const memberTransactionOrder = useApiPaymentTransaction(!isGuest && isTransactionOrder && countryCode
    ? {
      country_code: countryCode,
      payment_transaction_id: (transactionId || orderHash) ?? '',
      language,
    }
    : undefined)

  /** For guests */
  const guestTransactionOrder = useApiGetGuestPaymentTransactionRequest({ orderHash: isGuest ? orderHash : null })

  /** For archaic orders without supports to transactionId and orderHash */
  const oldOrderOrder = useApiWordPressOrder(isWordPressOrder
    ? {
      order_id: orderId,
      project_code: projectCode,
      country_code: countryCode,
    }
    : undefined)

  const order = isTransactionOrder
    ? isGuest ? guestTransactionOrder : memberTransactionOrder
    : oldOrderOrder
  return {
    order,
  }
}
